<template lang="pug">
  include ./../../vuek/mixins.pug

  +b.the-map-section
    t-section
      t-h2(white) {{content.header3}}
      t-h3 {{content.subHeader3}}
      +e.container
        +e.map
          t-map(
            :dataSet="dataToDisplay"
          )
        +e.info
          t-info(:dataSet="dataToDisplay" :margin="infoMargin")
      +e.P.map-legend {{content.mapLegend}}
      +e.legend
        +e.legend-cell(v-bind:style="bgColor(0)")
          +e.legend-label 0
        +e.legend-cell(v-bind:style="bgColor(25)")
          +e.legend-label 25
        +e.legend-cell(v-bind:style="bgColor(40)")
          +e.legend-label 40
        +e.legend-cell(v-bind:style="bgColor(55)")
          +e.legend-label 55
        +e.legend-cell(v-bind:style="bgColor(85)")
          +e.legend-label 70
        +e.legend-cell(v-bind:style="bgColor(100)")
          +e.legend-label 85
        +e.legend-cell
          +e.legend-label 100

</template>

<script>
import { mapGetters } from 'vuex';
import d3 from '@/tools/d3/d3';

import TSection from '@/components/TSection/TSection';
import TH2 from '@/components/TH2/TH2';
import TH3 from '@/components/TH3/TH3';
import TMap from '@/components/TMap/TMap';
import TInfo from '@/components/TInfo/TInfo';

export default {
  name: 'the-map-section',

  data() {
    return {
      infoMargin: {
        top: 20,
        bottom: 20,
        left: 0,
        right: 0,
      },
    };
  },

  computed: {
    dataToDisplay() {
      const dataToDisplay = [];

      for (let i = 0; i < this.dataSet.length; i += 1) {
        dataToDisplay.push({
          country: this.dataSet[i].country,
          ISO3: this.dataSet[i].ISO3,
          CPIScore: this.dataSet[i].CPIScore.y18,
          CPIScorePrev: this.dataSet[i].CPIScore.y17,
          name_ua: this.dataSet[i].name_ua,
          rank: this.dataSet[i].rank.y18,
        });
      }

      return dataToDisplay;
    },

    ...mapGetters({
      dataSet: 'allDataSet',
      content: 'getContent',
    }),
  },

  methods: {
    bgColor(x) {
      const colorScale = d3.scaleLinear()
        .domain([0, 25, 40, 55, 70, 85, 100])
        .range(['#a41d29', '#a41d29', '#d73127', '#f36d44', '#fdf8c1', '#fddf90', '#fdf8c1']);

      return {
        backgroundColor: x || x === 0 ? colorScale(x) : '#e0e0e0',
      };
    },
  },

  components: {
    TH2,
    TH3,
    TInfo,
    TMap,
    TSection,
  },
};
</script>


<style lang="scss">
@import '../../scss/styles';

.the-map-section {
  position: relative;
  width: 100%;
  overflow: auto;

  &__container {
    display: flex;
  }

  &__map {
    display: relative;
    width: 900px;
    height: 600px;
    margin: 40px 0px 0px;
  }

  &__info {
    width: 224px;
  }

  // BEGIN: Legend
  $legend-cell-size: 10px;

  &__map-legend {
    text-align: left;
    color: #fff;
    font-weight: 100;
    font-size: 12px;
    margin-bottom: 6px;
  }

  &__legend {
    display: flex;
  }

  &__legend-cell {
    position: relative;
    width: 4 * $legend-cell-size;
    height: $legend-cell-size;
  }

  &__legend-label {
    position: absolute;
    top: $legend-cell-size;
    left: 0;
    color: #fff;
    font-size: 10px;
  }
  // END: Legend
}
</style>



// WEBPACK FOOTER //
// src/components/TheMapSection/TheMapSection.vue